import {onFind} from "@elements/init-modules-in-scope";
import {on} from '@elements/dom-utils'

import './scripts/common';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();